const isOnTop = (onTop: boolean):boolean => 
     window.scrollY == 0
export { isOnTop };